import { parseParticipantMetadata } from "./helpers";
import { useLivekitLocalParticipant } from "./useLivekitLocalParticipant";

export const useLivekitLocalMetadata = () => {
  const participant = useLivekitLocalParticipant();
  const metadata = parseParticipantMetadata(participant);

  return {
    metadata,
  };
};
